import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import YouTubeIcon from "@material-ui/icons/YouTube";
import LanguageIcon from "@material-ui/icons/Language";
import Tooltip from "@material-ui/core/Tooltip";
import TwitterIcon from "@material-ui/icons/Twitter";
import Divider from "@material-ui/core/Divider";
import ProgressiveImage from "react-progressive-graceful-image";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "30%",
    borderRight: "3px solid #efa916",
    margin: "50px 0",
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  divider: {
    backgroundColor: "rgb(239, 169, 22)",
    margin: "10px",
  },
}));

export default function SuperStar(superstar) {
  const classes = useStyles();

  const { name, img, social, bio } = superstar.superstar;

  return (
    <Card className={classes.root}>
      <ProgressiveImage src={`${img}`} placeholder={`${img}`}>
        {(src) => (
          <CardMedia
            className={classes.media}
            image={`${src}`}
            title={`${name}`}
          />
        )}
      </ProgressiveImage>
      <CardContent>
        <Typography gutterBottom variant="h5" component="h2">
          {name}
        </Typography>
        <div className="bio">{bio}</div>
      </CardContent>
      <Divider />
      <CardActions>
        <span>Check Superstar</span>{" "}
        <span role="img" aria-label="star">
          👉
        </span>
        {social.map(
          (s) =>
            s.youtube && (
              <Tooltip key={s.youtube} title="YouTube" placement="top">
                <a
                  href={`${s.youtube}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <IconButton aria-label="add to favorites">
                    <YouTubeIcon />
                  </IconButton>
                </a>
              </Tooltip>
            )
        )}
        {social.map(
          (s) =>
            s.website && (
              <Tooltip key={s.website} title="Website" placement="top">
                <a
                  href={`${s.website}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <IconButton aria-label="add to favorites">
                    <LanguageIcon />
                  </IconButton>
                </a>
              </Tooltip>
            )
        )}
        {social.map(
          (s) =>
            s.twitter && (
              <Tooltip key={s.twitter} title="Twitter" placement="top">
                <a
                  href={`${s.twitter}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <IconButton aria-label="add to favorites">
                    <TwitterIcon />
                  </IconButton>
                </a>
              </Tooltip>
            )
        )}
      </CardActions>
    </Card>
  );
}
